var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/web.immediate.js
// module id = 1382
// module chunks = 168707334958949